import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { selectMappedFieldsFilteredByCulture } from '../../../slice/selectors';
import DisabledField from '../../fields/DisabledField/DisabledField';
import GeomanDrawPolygon from './parts/GeomanDrawPolygon';

interface IProps {}

const CreatePolygon: FC<IProps> = () => {
  const mappedFields = useSelector(selectMappedFieldsFilteredByCulture);

  return (
    <>
      <GeomanDrawPolygon />
      {mappedFields.map(mappedField => (
        <DisabledField mappedField={mappedField} key={mappedField.id} />
      ))}
    </>
  );
};

export default CreatePolygon;
